import { render, staticRenderFns } from "./CompositionApiLifecycle.vue?vue&type=template&id=ef4cef64&"
import script from "./CompositionApiLifecycle.vue?vue&type=script&lang=js&"
export * from "./CompositionApiLifecycle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports